// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0bd0be1e","455":"18d3c65e","977":"bb5aa810"}[chunkId] + ".chunk.js";
};